import hacknite from "../assets/Cetificates_src/hacknite.png";
import nss from "../assets/Cetificates_src/nss.png";
import iedc_summit_23 from "../assets/Cetificates_src/iedc_summit_23.png";
import gen_ai from "../assets/Cetificates_src/gen_ai_wrokshop.png";
import kiw_vol from "../assets/Cetificates_src/kiw_volunteer.png";
import poly_vol from "../assets/Cetificates_src/poly_volunteer.png";
import design_a_thon from "../assets/Cetificates_src/design_a_thon_kiw.png";
import d2c from "../assets/Cetificates_src/d2c.png";
import flutter_intership from "../assets/Cetificates_src/flutter_intership.png";

export const CertificateData = [
  {
    title: "D2C volunteer",
    src: d2c,
  },
  {
    title: "design-A-thon [kiw]",
    src: design_a_thon,
  },
  {
    title: "maintenance team",
    src: poly_vol,
  },
  {
    title: "flutter intership",
    src: flutter_intership,
  },
  {
    title: "KIW volunteer",
    src: kiw_vol,
  },
  {
    title: "gen ai workshop",
    src: gen_ai,
  },
  {
    title: "IEDC summit",
    src: iedc_summit_23,
  },
  {
    title: "hackSphere",
    src: nss,
  },
  {
    title: "hacknite",
    src: hacknite,
  },
];


export const AllImages = [
  {
    title:"img-26-01",
    src:"IMG-23_012.webp"
  },
  {
    title:"img-26-02",
    src:"IMG-23_011.webp"
  },
  {
    title:"img-26-03",
    src:"IMG-23_014.webp"
  },
  {
    title:"img-26-04",
    src:"IMG-23_08.webp"
  },
  {
    title:"img-26-05",
    src:"IMG-23_07.webp"
  },
  {
    title:"img-26-06",
    src:"IMG-23_024.webp"
  },
  {
    title:"img-26-06",
    src:"IMG-23_11.webp"
  },
  {
    title:"img-26-06",
    src:"IMG-23_22.webp"
  },
  {
    title:"img-26-07",
    src:"IMG-23_027.webp"
  },
  {
    title:"img-26-08",
    src:"IMG-23_026.webp"
  },
  {
    title:"img-25-09",
    src:"IMG-23_028.webp"
  },
  {
    title:"img-25-10",
    src:"IMG-23_029.webp"
  },
  {
    title:"img-25-11",
    src:"IMG-23_0%2024.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_016.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_023.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_09.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_010.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_021.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_022.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_020.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_017.webp"
  },
];

export const favourites = [
  {
    title:"img-25-12",
    src:"IMG-23_013.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_08.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_05.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_015.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_02.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_06.webp"
  },
  {
    title:"img-25-12",
    src:"IMG-23_07.webp"
  },
];

export const works = [
    {
    title:"img-25-12",
    src:"1.webp"
  },
  {
    title:"img-25-12",
    src:"2.webp"
  },
  {
    title:"img-25-12",
    src:"3.webp"
  },
  {
    title:"img-25-12",
    src:"4.webp"
  },
  {
    title:"img-25-12",
    src:"5.webp"
  },
  {
    title:"img-25-12",
    src:"6.webp"
  },
  {
    title:"img-25-12",
    src:"7.webp"
  },
  {
    title:"img-25-12",
    src:"8.webp"
  },
  {
    title:"img-25-12",
    src:"9.webp"
  },
  {
    title:"img-25-12",
    src:"10.webp"
  },
  {
    title:"img-25-12",
    src:"11.webp"
  },
  {
    title:"img-25-12",
    src:"12.webp"
  },
  {
    title:"img-25-12",
    src:"13.webp"
  },
  {
    title:"img-25-12",
    src:"14.webp"
  },
];